export const fetchUploadApi = (url, method, headers, body) => {
    return fetch(url, { method, headers, body })
        .then(response => {
            if (response.status > 200) {
                if (response.status == 401) {
                    localStorage.setItem('state', null);
                }
                // Errors such as this are passed up to the middleware
                throw new Error(`Server error: ${response.status} status`);
            }

            return response.json();
        })
        .then(response => {
            if (!response) {
                return response;
            } else if (response.errors) {
                throw new Error(`Server error: ${response.errors.message}`);
            }

            return response;
        });
}